<cads-field [config]="_fieldConfig()">
  <div class="cads-select">
    <button
      type="button"
      class="cads-select__trigger"
      [id]="_inputId()"
      [disabled]="_disabled()"
      [class.cads-select__trigger--open]="_panelOpenChrome()"
      [class.cads-select__trigger--error]="_hasError()"
      [attr.aria-invalid]="_hasError() ? 'true' : null"
      [attr.aria-required]="config().required === true ? 'true' : null"
      [attr.aria-describedby]="_showCaption() ? _captionId() : null"
      [attr.aria-expanded]="_panelOpen()"
      [attr.aria-controls]="_panelOpen() ? _listboxId() : null"
      aria-haspopup="listbox"
      (click)="_togglePanel()"
      (blur)="_onTriggerBlur()"
      (keydown)="_onTriggerKeydown($event)"
    >
      <span
        class="cads-select__value"
        [class.cads-select__value--placeholder]="_isPlaceholderActive()"
      >
        {{ _isPlaceholderActive() ? _placeholder() : _selectedLabel() }}
      </span>
      <span class="cads-select__chevron" [class.cads-select__chevron--open]="_chevronOpen()" aria-hidden="true">
        <svg viewBox="0 0 16 16" focusable="false">
          <path
            d="M4 6l4 4 4-4"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>

    <div class="cads-select__panel-clip" [class.cads-select__panel-clip--open]="_panelOpen()">
      <div class="cads-select__panel-inner">
        @if (_panelOpen()) {
          <div
            class="cads-select__panel"
            [id]="_listboxId()"
            role="listbox"
          >
            <ng-content select="[cadsSelectOptions]" />
            @if (!_customOptionsSlot) {
              @for (option of _optionsForTemplate(); track option.value; let last = $last) {
                <button
                  type="button"
                  class="cads-select__option"
                  [attr.data-option-value]="option.value"
                  [class.cads-select__option--selected]="option.value === _value()"
                  [disabled]="option.disabled === true"
                  role="option"
                  [attr.aria-selected]="option.value === _value() ? 'true' : 'false'"
                  (click)="_onDefaultOptionPick(option.value)"
                  (keydown)="_onOptionKeydown($event)"
                >
                  <span class="cads-select__option-main">
                    <span
                      class="cads-select__option-label"
                      [class.cads-select__option-label--selected]="option.value === _value()"
                    >
                      {{ option.label }}
                    </span>
                    @if (option.description) {
                      <span class="cads-select__option-desc">{{ option.description }}</span>
                    }
                  </span>
                  @if (option.value === _value()) {
                    <span class="cads-select__check" aria-hidden="true">✓</span>
                  }
                </button>
                @if (!last) {
                  <div class="cads-select__divider" role="presentation"></div>
                }
              }
            }
          </div>
        }
      </div>
    </div>
  </div>
  <ng-content select="[cadsFieldCaption]" />
</cads-field>
